import React from "react";

class PropsFormError extends React.PureComponent {
    render() {
        const errors = this.props.errors;

        return errors
            ? (
            <div className="form-error form-group has-error has-feedback">
                <span className="alert alert-danger help-block validation-message">{errors}</span>
            </div>
            )
            : null;
    }
}

module.exports = PropsFormError;